import React, { useState, useEffect } from 'react';
import styles from '../../app.module.css'

const ParametersForm = ({ initialData, isEditing, onSave, onCancel, existingParameters = [] }) => {
    const [parameter, setParameter] = useState({
        name: '',
        in: '',
        required: false,
        description: '',
        schema: { type: '', example: '' },
    });

    const [popupMessage, setPopupMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const showPopupModal = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
    }

    useEffect(() => {
        if (initialData) {
            setParameter({
                name: initialData.name || '',
                in: initialData.in || '',
                required: initialData.required || false,
                description: initialData.description || '',
                schema: initialData.schema || { type: '', example: '' },
            });
        } else {
            setParameter({
                name: '',
                in: '',
                required: false,
                description: '',
                schema: { type: '', example: '' },
            });
        }
    }, [initialData]);

    const handleInputChange = (field, value) => {
        setParameter((prev) => ({ ...prev, [field]: value }));
    };

    const handleSchemaChange = (field, value) => {
        setParameter((prev) => ({
            ...prev,
            schema: { ...prev.schema, [field]: value },
        }));
    };

    const handleSubmit = () => {
        if (!parameter.name || !parameter.in || !parameter.schema.type) {
            showPopupModal('Name, Location (in), and Schema Type are required.');
            return;
        }

        if (!isEditing && existingParameters.hasOwnProperty(parameter.name)) {
            showPopupModal(`A parameter with the name "${parameter.name}" already exists. Please choose a different name.`);
            return;
        }

        onSave(parameter.name, parameter);
    };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.style2}>
                <h3>{isEditing ? 'Edit Parameter' : 'Add Parameter'}</h3>

                <div className={styles.style3}>
                    <label>Name:<span className={styles.requiredField}>*</span></label>
                    <input
                        type="text"
                        value={parameter.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        readOnly={isEditing}
                        placeholder="Enter Parameter Name"
                        className={styles.textBox}
                    />
                </div>

                <div className={styles.style3}>
                    <label>Location (in):<span className={styles.requiredField}>*</span></label>
                    <select
                        value={parameter.in}
                        onChange={(e) => handleInputChange('in', e.target.value)}
                        className={styles.dropdown}
                    >
                        <option value="">Select Location</option>
                        <option value="query">Query</option>
                        <option value="header">Header</option>
                        <option value="path">Path</option>
                        <option value="cookie">Cookie</option>
                    </select>
                </div>

                <div className={styles.style3}>
                    <label>
                        <input
                            type="checkbox"
                            checked={parameter.required}
                            onChange={(e) => handleInputChange('required', e.target.checked)}
                        />
                        Required
                    </label>
                </div>

                <div className={styles.style3}>
                    <label>Description:</label>
                    <input
                        type="text"
                        value={parameter.description}
                        onChange={(e) => handleInputChange('description', e.target.value)}
                        placeholder="Enter Description"
                        className={styles.textBox}
                    />
                </div>

                <div className={styles.style3}>
                    <label>Schema Type:<span className={styles.requiredField}>*</span></label>
                    <select
                        value={parameter.schema.type}
                        onChange={(e) => handleSchemaChange('type', e.target.value)}
                        className={styles.dropdown}
                    >
                        <option value="">Select Type</option>
                        <option value="string">String</option>
                        <option value="integer">Integer</option>
                        <option value="boolean">Boolean</option>
                        <option value="array">Array</option>
                        <option value="object">Object</option>
                    </select>
                </div>

                <div className={styles.style3}>
                    <label>Example:</label>
                    <input
                        type="text"
                        value={parameter.schema.example}
                        onChange={(e) => handleSchemaChange('example', e.target.value)}
                        placeholder="Enter Example Value"
                        className={styles.textBox}
                    />
                </div>

                <div className={styles.sNcButtonContainer}>
                    <button
                        className={styles.saveButton}
                        onClick={handleSubmit}
                    >
                        {isEditing ? 'Update' : 'Save'}
                    </button>
                    <button
                        className={styles.cancelButton}
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
                {showPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popup}>
                            <h3>Error</h3>
                            <p>{popupMessage}</p>
                            <button onClick={() => setShowPopup(false)} className="popup-close-button">
                                OK
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ParametersForm;